var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 79,
    viewBox: "0 0 78 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_395_58894)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.842 65.6811C79.1184 51.2217 79.1184 27.7783 64.842 13.3189C50.5657 -1.14052 27.419 -1.14052 13.1427 13.3189C-1.13373 27.7783 -1.13373 51.2217 13.1427 65.6811C27.419 80.1405 50.5657 80.1405 64.842 65.6811Z",
    fill: "#F15249"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.0371 45.7813C72.4356 61.1986 60.4252 73.3623 45.2035 75.9974L25.5205 56.0621C20.8105 52.1252 17.8086 46.1673 17.8086 39.4992C17.8086 27.6448 27.2966 18.0352 39.001 18.0352C45.5847 18.0352 51.4671 21.0757 55.3542 25.846L75.0371 45.7813Z",
    fill: "#AD0E0E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.001 18.0352C50.7054 18.0352 60.1934 27.6448 60.1934 39.4992C60.1934 51.3537 50.7054 60.9633 39.001 60.9633C27.2966 60.9633 17.8086 51.3537 17.8086 39.4992C17.8086 27.6448 27.2966 18.0352 39.001 18.0352Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 48.5C33.45 48.5 32.9793 48.3043 32.588 47.913C32.1967 47.5217 32.0007 47.0507 32 46.5V33.5H31V31.5H36V30.5H42V31.5H47V33.5H46V46.5C46 47.05 45.8043 47.521 45.413 47.913C45.0217 48.305 44.5507 48.5007 44 48.5H34ZM36 44.5H38V35.5H36V44.5ZM40 44.5H42V35.5H40V44.5Z",
    fill: "#AD0E0E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_395_58894"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 78,
    height: 79,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/deleteIcon.9527d49d7d2ab99661dc811c824e569b.svg";
export { ForwardRef as ReactComponent };